import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
FaEnvelope,
FaLock,
FaEye,
FaEyeSlash
} from "react-icons/fa";

function LoginTenagaKesehatan() {

const navigate = useNavigate();

const [email, setEmail] = useState("");
const [password, setPassword] = useState("");
const [rememberMe, setRememberMe] = useState(false);
const [showPassword, setShowPassword] = useState(false);
const [loading, setLoading] = useState(false);

const [modal, setModal] = useState({
show: false,
title: "",
message: "",
success: false,
});

const showAlert = (title, message, success) => {
setModal({ show: true, title, message, success });
};

const login = async () => {
setLoading(true);

try {
const res = await fetch(
"http://192.168.1.6:5000/api/login-tenaga-kesehatan",
{
method: "POST",
headers: {
"Content-Type": "application/json",
},
body: JSON.stringify({
email: email,
password: password,
}),
}
);

const data = await res.json();

if (res.ok) {

showAlert(
"Login Berhasil!",
`Selamat datang, ${data.user.username}`,
true
);

setTimeout(() => {
navigate("/home");
}, 2000);

} else {

showAlert(
"Login Gagal",
data.message || "Email atau password salah",
false
);

}

} catch (err) {
showAlert(
"Error",
"Tidak dapat terhubung ke server",
false
);
}

setLoading(false);
};

return (
<div className="min-h-screen bg-white flex items-center justify-center px-6">

<div className="w-full max-w-md">

{/* TITLE */}
<h1 className="text-3xl font-bold text-center text-[#64B5F6] mb-8">
Login
</h1>

{/* CARD BOX */}
<div className="bg-white rounded-2xl shadow-lg p-6">

{/* EMAIL */}
<div className="bg-gray-200 flex items-center rounded-xl px-4 mb-4">
<FaEnvelope className="text-gray-500" />
<input
className="w-full bg-transparent p-4 outline-none"
placeholder="Email"
value={email}
onChange={(e) => setEmail(e.target.value)}
/>
</div>

{/* PASSWORD */}
<div className="bg-gray-200 flex items-center rounded-xl px-4 mb-4">
<FaLock className="text-gray-500" />
<input
className="w-full bg-transparent p-4 outline-none"
placeholder="Enter your password"
type={showPassword ? "text" : "password"}
value={password}
onChange={(e) => setPassword(e.target.value)}
/>

<button
type="button"
onClick={() => setShowPassword(!showPassword)}
className="ml-2 text-gray-600"
>
{showPassword ? <FaEyeSlash /> : <FaEye />}
</button>
</div>

{/* REMEMBER + FORGOT */}
<div className="flex justify-between items-center text-sm mb-5">

<label className="flex items-center gap-2">
<input
type="checkbox"
checked={rememberMe}
onChange={() => setRememberMe(!rememberMe)}
/>
Remember me
</label>

<span className="text-[#64B5F6] cursor-pointer">
Forgot password?
</span>

</div>

{/* LOGIN BUTTON */}
<button
onClick={login}
disabled={loading}
className="w-full bg-[#64B5F6] text-white py-3 rounded-xl font-semibold"
>
{loading ? "Loading..." : "Login"}
</button>

</div>

{/* OR CONNECT */}
<div className="flex items-center my-6">

<div className="flex-1 border-t"></div>

<span className="px-3 text-sm text-gray-500">
or connect with
</span>

<div className="flex-1 border-t"></div>

</div>

{/* GOOGLE LOGIN */}
<div className="flex justify-center">
<img
onClick={() => alert("Google login belum dihubungkan")}
src="https://pngimg.com/uploads/google/google_PNG19635.png"
className="w-10 cursor-pointer"
/>
</div>

{/* SIGN UP */}
<p className="text-center mt-6 text-sm">
Don't have account?
<Link
to="/registertenagakesehatan"
className="text-[#64B5F6] font-semibold ml-2"
>
Sign up
</Link>
</p>

</div>

{/* MODAL ALERT */}
{modal.show && (
<div className="fixed inset-0 bg-black/40 flex items-center justify-center">

<div className="bg-white p-6 rounded-2xl w-80 text-center">

<div
className={`text-4xl mb-2 ${
modal.success ? "text-blue-500" : "text-red-500"
}`}
>
{modal.success ? "✔" : "✖"}
</div>

<h2 className="font-bold text-lg mb-2">
{modal.title}
</h2>

<p className="text-sm text-gray-600 mb-4">
{modal.message}
</p>

<button
onClick={() => setModal({ ...modal, show: false })}
className="bg-[#64B5F6] text-white px-5 py-2 rounded-lg"
>
OK
</button>

</div>

</div>
)}

</div>
);
}

export default LoginTenagaKesehatan;